<template>
    <card :minify="minified">
        <card-header v-if="!minified">
            <card-title>
                <translate>unbestätigte Aufträge</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped">
                <thead>
                <tr>
                    <th><translate>PF-Nr</translate></th>
                    <th class="text-center"><translate>Zeichnung</translate></th>
                    <th class="text-right"><translate>Stück</translate></th>
                    <th class="text-right"><translate>Auftragspreis</translate></th>
                    <th class="text-right"><translate>geplanter Versandtermin</translate></th>
                    <th class="text-right"><translate>Liefertermin</translate></th>
                    <th class="text-right"><translate>Bestelldatum</translate></th>
                    <th class="text-center"><translate>Bestellung</translate></th>
                    <th class="text-center"><translate>bestätigen<span>verbindlich</span></translate></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="order in newOrdersTable" :key="order.index">
                    <td>
                        <Link :href="order.url">{{ order.ask_for_quote.pfnumber }}</Link>
                    </td>
                    <td class="text-center">
                        <file-download :sketch-file="order.ask_for_quote?.producer_sketch_file" v-if="order.ask_for_quote?.producer_sketch_file"/>
                        <file-download :cad-file="order.ask_for_quote?.producer_cad_file" v-if="order.ask_for_quote?.producer_cad_file"/>
                    </td>
                    <td class="text-right">{{ order.amount }}</td>
                    <td class="text-right">{{ order.price_string }}</td>
                    <td class="text-right">{{ order.shipping_date }}</td>
                    <td class="text-right">{{ order.delivery_date_string }}</td>
                    <td class="text-right">{{ order.created_at_string }}</td>
                    <td class="text-center">
                        <form-link :href="order.url" dense="true" icon="contract-document-seal" method="get" />
                    </td>
                    <td class="text-center">
                        <form @submit.prevent="confirmOrder(order.id)">
                            <form-button color="secondary" dense="true" icon="done-check-checkmark" />
                        </form>
                    </td>
                </tr>
                <tr v-if="noOrders">
                    <td colspan="9" class="text-center">
                        <strong>
                            <translate>keine Einträge vorhanden</translate>
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FileDownload from '@partfactory/Shared/Elements/FileDownload';
import FormLink from '@partfactory/Shared/Form/FormLink';
import {useForm} from '@inertiajs/vue3';

export default {
    name: 'DashboardNewOrders',
    components: {FormLink, FileDownload, FormButton, CardContent, CardTitle, CardHeader, Card},
    props: {
        newOrders: Object,
        minified: Boolean,
    },
    computed: {
        newOrdersTable() {
            let orders = Array;

            return Object.keys(this.newOrders).map(key => {
                orders[key] = this.newOrders[key];

                orders[key].url = this.$$route('order', {'producerOrder' : orders[key].id});

                orders[key].price_string = this.$currency(orders[key].price);

                orders[key].created_at_string = this.$date(orders[key].created_at);

                orders[key].delivery_date_string = this.$date(orders[key].delivery_date);

                orders[key].shipping_date = this.$moment(orders[key].delivery_date).subtract(this.$page.props.factors.delivery_time_producer_part, 'days').format('DD.MM.YYYY');

                return orders[key];
            });
        },
        noOrders() {
            return this.newOrders.length === 0;
        },
    },
    data() {
        const form = useForm({});
        return { form };
    },
    methods: {
        confirmOrder(producerOrder) {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('order.confirm', {'producerOrder' : producerOrder}), {
                    preserveScroll: true,
                });
        },
    },
};
</script>
